
import React, { useEffect, useRef } from 'react'
import Page from '../components/Page'
import Video from '../components/Main/Video'
import Link from 'next/link'
import LazyImage from '../components/LazyImage'
import LargeButtons from '../components/Main/LargeButtons'

export default function Donate (props) {
  const { 
    title: heading, 
    content: content, 
    slug: slug,
  } = props.wp

  const {
    //Large Buttons
    large_buttons: largeButtons,

    //Image
    image: image,

    //Video
    include_video: includeVideo,
    video_poster: videoPoster,
    video_url: videoUrl,
  } = props.acf

  return (
    <React.Fragment>
      <Page
        title={heading.rendered}
        slug={'/' + slug}
        body={
          'This is the donation page for supporting The Quell Foundation. To donate follow one of the links below.'
        }
      >
        <main id='content'>
          <div className='container donate-hero'>
            <LazyImage
              key={image.ID}
              src={image.url}
              alt={image?.alt || image?.name || "Quell"}
              containClass="donate-img-contain"
            />
            {/* <h1
              className='heading2 text-center'
              dangerouslySetInnerHTML={{ __html: heading.rendered }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: content.rendered //props.page.fullArticle.content.rendered
              }}
            /> */}
            <LargeButtons buttons={largeButtons} />
          </div>
          {includeVideo &&
            <div className='donate-video-section'>
              <Video poster={videoPoster} url={videoUrl} />
            </div>
          }
        </main>
      </Page>
    </React.Fragment>
  )
}
